import React, { FC, memo } from 'react';
import triggerTracking from '@blueprint/tracking';
import { Icon } from '@blueprint/ui';

import { StyledMapIconLink } from './MapIcon.styles';

type mapIconProps = {
    href: string;
};

const MAP_VIEW_TEXT = 'Map view';

export const MapIcon: FC<mapIconProps> = memo(({ href }) => {
    return (
        <StyledMapIconLink
            variant="tertiary"
            href={href}
            data-testid="map-view-link"
            rel={'nofollow'}
            onClick={() =>
                triggerTracking({
                    event: 'GAEvent',
                    eventCategory: 'search results',
                    eventAction: 'clickthrough',
                    eventLabel: 'view_type_map'
                })
            }
        >
            <Icon iconId="location_pin" size="small" />
            {MAP_VIEW_TEXT}
        </StyledMapIconLink>
    );
});

MapIcon.displayName = 'MapIconComponent';
